import { ProspectClient } from "../../../../../../Wrap/Api/Customer/Prospect";
import { Prospect } from "../../../../../../Wrap/Models/Models/Customer/Prospect";
import { Organisation } from "../../../../../../Wrap/Models/Models/Customer/Organisation";
import { OrganisationClient } from "../../../../../../Wrap/Api/Customer/Organisation";
import { AddClientDispatcher } from "../Stores/Variable";
import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { CompanyServicePropositionClient } from "../../../../../../Wrap/Api/Company/CompanyServiceProposition";

export class AddClientAction {
    public static submitClientDetails(clientModel: Prospect, callBack?) {
        const client = new ProspectClient();
        const promise = client
            .post(clientModel)
            .onSuccess((data) => {
                AddClientDispatcher.dispatch({
                    actionType: ActionType.Success,
                    payload: data,
                });
                if (callBack) {
                    callBack(data);
                }
            })
            .onError((error) => {
                AddClientDispatcher.dispatch({
                    actionType: ActionType.Error,
                    payload: error,
                });
            });
        return promise;
    }

    public static getCompanyProposition(hierarchy: string, callBack?) {
        const client = new CompanyServicePropositionClient();
        const promise = client
            .get(0, hierarchy)
            .onSuccess((data) => {
                if (callBack) {
                    callBack(data);
                }
            })
            .onError((error) => {});
        return promise;
    }

    public static submitTrustDetail(organisation: Organisation, callBack?) {
        const client = new OrganisationClient();
        const promise = client
            .post(organisation)
            .onSuccess((data) => {
                AddClientDispatcher.dispatch({
                    actionType: ActionType.Success,
                    payload: data,
                });
                if (callBack) {
                    callBack(data);
                }
            })
            .onError((error) => {
                AddClientDispatcher.dispatch({
                    actionType: ActionType.Error,
                    payload: error,
                });
            });
        return promise;
    }
}
